import DashboardLayout from "../../../shared/DashboardLayout";

const categories = [
  { id: 1, name: "Expense By" },
  { id: 2, name: "Expense Type" },
  { id: 3, name: "Labor Categories" },
  { id: 4, name: "Material Categories" },
  { id: 5, name: "Employee Salary" },
];

const SearchCategories = () => {
  return (
    <DashboardLayout>
      <h2 className="m-4">Expenses Categories</h2>
      <div className="row m-4">
        <div className="col-lg-12 col-sm-6">
          <table className="table table-striped w-100">
            <thead className="table-dark">
              <tr>
                <th>ID</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr key={category.id}>
                  <td>{category.id}</td>
                  <td>
                    {category.name} <br />
                    <a href={`${category.id}`} className="text-decoration-none">
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
            <thead className="table-dark">
              <tr>
                <th>ID</th>
                <th>Name</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SearchCategories;
